import React from 'react';
import AppHeader from '../../components/Header/Header';
import AppLayout from '../../components/layout';
import BannerSection from '../../components/ui/BannerSection';
import AreaCientifica from '../../components/ui/AreaCientifica';
import SectionHeading from '../../components/SectionHeading';
import BreadcrumbNav from '../../components/ui/BreadcrumbNav';

const caminho = [
  { label: 'Home', href: '/', icon: 'bi bi-house-door' },
  { label: 'Área Científica' },
  { label: 'Biblioteca virtual' },
];

function BibliotecaVirtual() {
    return (
        <>
            <header id="header">
                <AppHeader />
            </header>
            <BannerSection
                title="Biblioteca Virtual"
                subtitle="Bem-vindo à Biblioteca Virtual do ISP-Atlântida"
                description="Explore um repositório digital com acesso a artigos, teses e publicações científicas. Enriquecer seu conhecimento nunca foi tão fácil."
                backgroundImage={require('../../assets/Bannervirtual.jpg')}
                backgroundId="instituition-Banner"
            />
            <BreadcrumbNav items={caminho} />
            <main className="px-3 px-md-5 px-xl-5 px-xxl-5 py-2">
                <div className="row flex-row-reverse">
                    
                    <div className="col-12 col-md-4 col-lg-3 col-xl-2 col-xxl-2 menu-color">
                        <br />
                        <AreaCientifica />
                    </div>
                    <div className="col-12 col-md-8 col-lg-9 col-xl-10 col-xxl-10">
                        <section
                            className="details-magazine modern-card shadow-lg rounded-4 p-4 bg-white animate__animated animate__fadeIn"
                            id="detalhes"
                            style={{
                                border: '1px solid #e3e6f0',
                                marginTop: '2rem',
                                background: 'rgba(255,255,255,0.95)',
                            }}
                        >
                            <SectionHeading title="Biblioteca Virtual" />
                            <div className="mb-4 mt-3">
                                <span
                                    className="badge rounded-pill px-3 py-2 fs-6"
                                    style={{ letterSpacing: '1px', backgroundColor: '#00761F', color: '#fff' }}
                                >
                                    Acesso Livre
                                </span>
                            </div>
                            <p className="lead text-secondary mb-4">
                                Descubra uma vasta gama de recursos acadêmicos: artigos, teses, dissertações e publicações científicas para alunos, professores e pesquisadores.
                            </p>
                            <ul className="list-unstyled mb-4">
                                <li className="mb-2">
                                    <i className="bi bi-journal-text text-ispa me-2"></i>
                                    <strong>Repositório Digital:</strong> Acesso rápido e eficiente a conteúdos científicos.
                                </li>
                                <li className="mb-2">
                                    <i className="bi bi-people text-ispa me-2"></i>
                                    <strong>Colaboração:</strong> Espaço para troca de experiências entre investigadores, docentes e discentes.
                                </li>
                                <li className="mb-2">
                                    <i className="bi bi-lightbulb text-ispa me-2"></i>
                                    <strong>Incentivo à Pesquisa:</strong> Motive-se a desenvolver habilidades em investigação científica.
                                </li>
                            </ul>
                            <div className="alert d-flex align-items-center mb-4" role="alert" style={{ backgroundColor: '#00761F', borderColor: '#e3e6f0', color: '#fff' }}>
                                <i className="bi bi-globe2 fs-3 me-3 text-primary"></i>
                                <div>
                                    <strong>Explore agora:</strong> Acesse nossa biblioteca virtual e descubra um mundo de conhecimento ao seu alcance.
                                </div>
                            </div>
                            <div className="text-center">
                                <a
                                    href="https://lbs.livweb.co/lib_ispa/login.php"
                                    className="btn btn-lg btn-gradient-primary px-5 py-3 fw-bold shadow"
                                    style={{
                                        background: 'linear-gradient(90deg, #F8C304 0%, #00761F 100%)',
                                        color: '#fff',
                                        border: 'none',
                                    }}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <i className="bi bi-box-arrow-up-right me-2"></i>
                                    Acessar Biblioteca Virtual
                                </a>
                            </div>
                        </section>
                    </div>
                </div>
            </main>
            <AppLayout />
        </>
    );
}

export default BibliotecaVirtual;